import React from "react";

import { Card, CardContent, Chip, Typography, useTheme } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import useColourPalette from "components/visuals/useColourPalette";

import { selectHasPrediction, selectPredictedCatchments } from "modules/customer/tools/location/overview/overviewSlice";
import { useAppSelector } from "store";

const StyledCard = withStyles(theme => ({
    root: {
        position: "absolute",
        zIndex: theme.zIndex.drawer,
        margin: theme.spacing(2),
        bottom: theme.spacing(2),
        width: theme.spacing(22),
        // @ts-ignore
        backgroundColor: theme.palette.background.insight
    }
}))(Card);

const StyledCardContent = withStyles(theme => ({
    root: {
        "&:last-child": {
            padding: theme.spacing(2)
        }
    }
}))(CardContent);

const StyledChip = withStyles(theme => ({
    root: {
        backgroundColor: (props: any) => props["data-background-color"],
        width: theme.spacing(3),
        height: theme.spacing(1.5)
    }
}))(Chip);

const Legend: React.FC = () => {
    const colourPalette = useColourPalette();
    const theme = useTheme();
    const hasPrediction = useAppSelector(selectHasPrediction);
    const predictedCatchments = useAppSelector(selectPredictedCatchments);
    const customLegend = hasPrediction && predictedCatchments && predictedCatchments?.length > 0;
    
    return (
        <StyledCard elevation={0}>
            <StyledCardContent>
                <Typography variant="body1" component="div" gutterBottom style={{ color: theme.palette.text.disabled }}>
                    {`${customLegend ? "Catchment bands" : "Likelihood of visit thresholds"}`}
                </Typography>
                <Typography variant="body1" component="div" gutterBottom>
                    <StyledChip size="small" data-background-color={customLegend ? colourPalette.revenuePrediction[0] : colourPalette.sequential[0]} />
                    &nbsp;&nbsp;{`${customLegend ? "0% - 20%" : "> 80%"}`}
                </Typography>
                <Typography variant="body1" component="div" gutterBottom>
                    <StyledChip size="small" data-background-color={customLegend ? colourPalette.revenuePrediction[1] : colourPalette.sequential[1]} />
                    &nbsp;&nbsp;{`${customLegend ? "20% - 40%" : "80% - 60%"}`}
                </Typography>
                <Typography variant="body1" component="div" gutterBottom>
                    <StyledChip size="small" data-background-color={customLegend ? colourPalette.revenuePrediction[2] : colourPalette.sequential[2]} />
                    &nbsp;&nbsp;{`${customLegend ? "40% - 60%" : "60% - 40%"}`}
                </Typography>
                <Typography variant="body1" component="div" gutterBottom>
                    <StyledChip size="small" data-background-color={customLegend ? colourPalette.revenuePrediction[4] : colourPalette.sequential[3]} />
                    &nbsp;&nbsp;{`${customLegend ? "60% - 80%" : "40% - 20%"}`}
                </Typography>
                {!customLegend && (<Typography variant="body1" component="div" gutterBottom>
                    <StyledChip size="small" data-background-color={customLegend ? colourPalette.revenuePrediction[4] : colourPalette.sequential[4]} />
                    &nbsp;&nbsp;{"< 20%"}
                </Typography>)}
            </StyledCardContent>
        </StyledCard>
    );
};

export default Legend;
